import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getCargos = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/cargos?empresa=${userInfo.empresa}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


  export const getCargosEstado = async (estado) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/cargos/estado?empresa=${userInfo.empresa}&estado=${estado}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearCargo = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/cargos', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateCargo = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/cargos/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteCargo = (Id) => Axios.delete(`/cargos/${Id}`);